<div
  class="font-family-din flex min-w-xs place-content-center gap-2 rounded-xl border-2 border-red-500 p-4 text-lg font-bold transition-colors select-none"
  [class]="{
    'bg-red-500': duration() === 0,
    'bg-red-50': duration() !== 0,
    'text-white': duration() === 0,
    'text-red-500': duration() !== 0,
  }"
>
  <div
    class="ease-out-back flex w-max items-center gap-2 transition-transform duration-250"
    [class]="{
      'scale-120': duration() === 0,
    }"
  >
    <i-timer class="inline-block size-[1em] -translate-y-0.5" [class]="animationClass()" />
    <span class="tracking-wider">{{ durationString() }}</span>
  </div>
</div>
